<kendo-dialog-titlebar>
    {{caption | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <form [formGroup]="form">

            <city-combo-select-ctrl [caption]="'addressForm.city'" [settings]="{fxFill:true}"
            [formControlName]="'selectedCity'"></city-combo-select-ctrl>

    </form>
    
    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>